import { Spinner } from "react-bootstrap";
import React, { useEffect, useRef, useState } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { useCounterContext } from "../../context/CounterContext";
import ErrorBoundary from "../../../../Utils/ErrorBoundary";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { convertDateToUserTimezone } from "../../GetMeeting/Helpers/functionHelper";

function formatTimeMMSS(seconds) {
  if (isNaN(seconds) || seconds < 0) {
    return "Invalid input";
  }
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  // Add leading zeros if needed
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(remainingSeconds).padStart(2, "0");

  return `${formattedMinutes}:${formattedSeconds}`;
}

const convertHoursToSeconds = (hours) => {
  return hours * 60 * 60; // 1 hour = 60 minutes, 1 minute = 60 seconds
};
function formatTimeHHMM(seconds) {
  if (isNaN(seconds) || seconds < 0) {
    return "Invalid input";
  }
  const hours = Math.floor(seconds / 3600);
  const remainingSeconds = seconds % 3600;
  const minutes = Math.floor(remainingSeconds / 60);

  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");

  return `${formattedHours}h:${formattedMinutes}`;
}

const convertDaysToSeconds = (days) => {
  return days * 24 * 60 * 60; // 1 day = 24 hours, 1 hour = 60 minutes, 1 minute = 60 seconds
};
const formatTimeDDHH = (seconds) => {
  const days = Math.floor(seconds / (24 * 60 * 60));
  const remainingSeconds = seconds % (24 * 60 * 60);
  const hours = Math.floor(remainingSeconds / (60 * 60));

  const formattedDays = days > 0 ? String(days).padStart(2, "0") : "00";
  const formattedHours = hours > 0 ? String(hours).padStart(2, "0") : "00";

  return `${formattedDays}d:${formattedHours}h`;
};

/**-----------------------------------------FUNCTIONAL COMPONENT STARTS HERE... -------------------------------------------- */
const CounterContainer = ({
  alarm,
  progress,
  estimateTime,
  estimateDate,
  isModalOpen,
  stepTitle,
  stepOrder,
}) => {
  const audioRef = useRef(null);
  // const [buzzer] = useState(new Audio(`https://tektime.io/Final-Countdown.mp3`));
  // const [audio] = useState(new Audio(`https://tektime.io/beep.WAV`));

  const [audio] = useState(
    new Audio(`https://tektime-storage.s3.eu-north-1.amazonaws.com/beep.WAV`)
  );
  const [buzzer] = useState(
    new Audio(
      `https://tektime-storage.s3.eu-north-1.amazonaws.com/Final-Countdown+(mp3cut.net)+(1).mp3`
    )
  );
  const [t] = useTranslation("global");
  const prevStepRef = useRef(false);
  const nextStepRef = useRef(false);
  const {
    activeStepIndex,
    meetingData,
    handleSetSavedTime,
    negativeTimes,
    setNegativeTimes,
    setNextActiveStep,
    setPreviousActiveStep,
    stepDelay,
    nextStepTrigger,
    previousStepTrigger,
    showNegativeCounter,
    setShowNegativeCounter,
  } = useCounterContext();
  const [duration, setDuration] = useState(0);
  const [initialRemainingTimeState, setInitialRemainingTimeState] = useState(0);
  const remainingTimeRef = useRef(0);
  const [totalElapsedTimeState, setTotalElapsedTimeState] = useState(0);
  const [meetingStartTime, setMeetingStartTime] = useState(new Date()); // will be set to the start time of the meeting. [hours,minutes]
  const [leftDuration, setLeftDuration] = useState(0);
  const [rightDuration, setRightDuration] = useState(0);
  const [currentStepDate, setCurrentStepDate] = useState(null);
  // const [showNegativeCounter, setShowNegativeCounter] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [isGrowing, setIsGrowing] = useState(false);
  const [centerColor, setCenterColor] = useState("#5AAFD6");
  const [redColor, setRedColor] = useState("red");
  // const [centerColor, setCenterColor] = useState('#5AAFD6');
  const [leftColor, setLeftColor] = useState("#eee");
  const [startingAlert, setStartingAlert] = useState("");
  const [startingAlertColor, setStartingAlertColor] = useState("0000");
  const [spareTimes, setSpareTimes] = useState([]);
  // Inititalize the spareTimes array with the length of the steps array. It will be used to store the spare time of each step.
  const [isPlaying, setIsPlaying] = useState(false); // Add state for playing
  const [remainingTime, setRemainingTime] = useState(null); // Add state for playing
  console.log("remainingTime", remainingTime);
  const [isOnPage, setIsOnPage] = useState(true);
  const [leavingTime, setLeavingTime] = useState(0);
  /**----------------------------------------------------------- SIDE EFFECTS ------------------------------------------------------------------------- */

  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);

  // withTimeZone
  useEffect(() => {
    if (meetingData?.starts_at && (meetingData?.timezone || "Europe/Paris")) {
      const meetingTimezone = meetingData.timezone;
      const userTimezone = moment.tz.guess();

      // Convert time from meeting's timezone to user's timezone
      const timeInMeetingTZ = moment.tz(
        meetingData.starts_at,
        "HH:mm",
        meetingTimezone
      );
      const timeInUserTZ = timeInMeetingTZ.clone().tz(userTimezone);

      // Extract hours and minutes
      setHours(timeInUserTZ.hours());
      setMinutes(timeInUserTZ.minutes());
    }
  }, [meetingData]);

  useEffect(() => {
    if (progress) return;
    // console.log(spareTimes);
    setShowNegativeCounter(false); // will update conditionally later.
    // setCenterColor()
    // Set The Duration of Center Counter.
    if (
      meetingData &&
      meetingData?.steps &&
      negativeTimes[activeStepIndex] > 0 &&
      meetingData?.steps[activeStepIndex]?.delay === null
    ) {
      setShowNegativeCounter(true);
      /**
       * setShowNegativeCounter STATE WILL BE BY DEFAULT FALSE. ON EVERY UPDATE OF STEP INDEX IT WILL BE SET TO FALSE. AND ...
       * IF THERE IS NEGATIVE TIME FOR THE ACTIVE STEP, setShowNegativeCounter WILL BE SET TO TRUE.
       * IMPORTANT:-> IF THE NEGATIVE TIME FOR ACTIVE STEP EXISTS i.e. > 0 ,
       * THEN THE DURATION OF THE CENTER COUNTER WILL BE SET TO 7200 MINUS THE NEGATIVE TIME OF THAT STEP SO THAT THE NEGATIVE TIME STARTS FROM WHERE IT LEFT
       */
      setDuration(7200 - negativeTimes[activeStepIndex]);
      return;
    }

    // IF THERE IS NO NEGATIVE TIME => THE DURATION OF THE CENTER COUNTER WILL BE SET TO THE SAVED TIME || THE TOTAL TIME OF THE ACTIVE STEP.
    const steps = meetingData.steps;
    if (Array.isArray(steps) && steps.length > 0) {
      const step = steps[activeStepIndex];
      if (step.time_unit === "days") {
        const count2InSeconds = convertDaysToSeconds(step.time);
        setDuration(step.savedTime || count2InSeconds);
      } else if (step.time_unit === "hours") {
        const count2InSeconds = convertHoursToSeconds(step.time);
        setDuration(step.savedTime || count2InSeconds);
      } else if (step.time_unit === "seconds") {
        setDuration(step.time); // Directly set the time for seconds
      } else {
        setDuration(step.savedTime || step.time * 60);
      }

      // setDuration(step.savedTime || step.time * 60);
    }
    setCenterColor("#5AAFD6"); // reset the color of the center counter.
  }, [activeStepIndex, meetingData, progress]);

  useEffect(() => {
    if (progress) return;

    // SET RIGHT DURATION i.e., the time when the meeting will end.:
    if (loaded === false && !meetingData) {
      // For only one time:
      return;
    }
    if (meetingData && loaded === false) {
      //------ Initializing here! ------
      setSpareTimes(new Array(meetingData.steps.length).fill(0));
      //-------
      const totalTimesArray = meetingData?.steps?.map((step) => {
        if (!step.savedTime) {
          let count2InSeconds;
          // Convert based on time_unit
          switch (step.time_unit) {
            case "hour":
            case "hours":
              count2InSeconds = parseInt(step.count2) * 3600;
              break;
            case "minute":
            case "minutes":
              count2InSeconds = parseInt(step.count2) * 60;
              break;
            case "second":
            case "seconds":
              count2InSeconds = parseInt(step.count2);
              break;
            default:
              count2InSeconds = parseInt(step.time) * 60; // Default case: Convert `time` to seconds by assuming minutes
          }
          return count2InSeconds;
        }
        let elapsedTime = parseInt(step.time) - parseInt(step.savedTime);
        // console.log("ELAPSED TIME: ", elapsedTime);
        return parseInt(step.time) - parseInt(elapsedTime);
      });

      // console.log("TOTAL TIMES ARRAY: ", totalTimesArray);
      let totalTime = totalTimesArray?.reduce((acc, curr) => acc + curr, 0);
      /**
       * HERE WE NEED TO SUBTRACT THE LAST STEP TIME FROM THE TOTAL TIME OF THE MEETING. as per client's requirement.
       * Which is obviuosly a stupid requirement. But we have to do it. So If by any chance, you need to remove this subtraction,
       * then you can remove it. But I am keeping it here for now. Remember, this is a temporary JUGAR and an imperfection to the functionality.
       *  */
      // const lastStepTime = totalTimesArray[totalTimesArray.length - 1];
      // totalTime = totalTime - lastStepTime;
      setRightDuration(totalTime);
      setLoaded(true);
    }
  }, [meetingData, loaded, progress]);

  const stopAudio = () => {
    buzzer.pause(); // Pause the buzzer audio
    buzzer.currentTime = 0; // Reset the playback position to start
  };

  const [buzzerPlayed, setBuzzerPlayed] = useState(false);
  const playAudio = () => {
    audio.play().catch((err) => {
      console.log("err", err);
    });
  };

  const playBuzzer = () => {
    buzzer.play().catch((err) => {
      console.log("err", err);
    });
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setRemainingTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (meetingData) {
      if (remainingTime <= 5 && remainingTime > 1 && alarm === true) {
        playAudio();
      } else if (
        remainingTime === 0 &&
        alarm === true &&
        meetingData?.steps[activeStepIndex]?.negative_time !== "99"
      ) {
        playBuzzer();
        setBuzzerPlayed(true);
      }
    }
  }, [remainingTime]);

  useEffect(() => {
    if (progress) return;

    if (nextStepRef.current) {
      stopAudio();
      const spareTimeToBeSubtracted = spareTimes[activeStepIndex - 1];
      setRightDuration((prev) => {
        return prev - spareTimeToBeSubtracted;
      });
    }
    return () => {
      nextStepRef.current = true;
    };
  }, [nextStepTrigger, progress]);

  useEffect(() => {
    if (progress) return;

    if (prevStepRef.current) {
      stopAudio();
      const spareTimeToBeAdded = spareTimes[activeStepIndex];
      setRightDuration((prev) => {
        return prev + spareTimeToBeAdded;
      });
    }

    return () => {
      prevStepRef.current = true;
    };
  }, [previousStepTrigger, progress]);

  /**------------------------------------------------------------------------------------------------------------------------- */

  const getLeftColors = async (meetingData) => {
    const green = "#39FF14";
    // const red = "#FF0000";
    const red = "url(#your-unique-id2)";
    const orange = "#f67913";
    if (meetingData && meetingData.start_time && meetingData.starts_at) {
      const [startHours, startMinutes] = meetingData?.start_time
        ?.split(":")
        .map(Number);
      const [startAtHours, startAtMinutes] = meetingData?.starts_at
        ?.split(":")
        .map(Number);

      // Create Date objects for the meeting time
      const meetingStartTime = new Date();
      meetingStartTime.setHours(startHours, startMinutes, 0, 0);

      const actualStartTime = new Date();
      actualStartTime.setHours(startAtHours, startAtMinutes, 0, 0);

      // Calculate the delay in minutes
      const delayInMilliseconds = actualStartTime - meetingStartTime;
      const delay = Math.floor(delayInMilliseconds / 60000); // Convert milliseconds to minutes

      /**
       * FOLLOWING CODE EXPLANATION:
       * IF THE MEETING STARTED EARLY, THE LEFT COUNTER WILL BE GREEN.
       * IF THE MEETING STARTED LATE, BUT THE DIFFERENCE BETWEEN TIME IS UP TO 5 MINUTES, THEN THE LEFT COUNTER WILL BE ORANGE.
       * IF THE MEETING STARTED LATE, AND THE DIFFERENCE IS GREATER THAN 5 MINUTES, THEN THE LEFT COUNTER WILL BE RED.
       */

      // Set alerts and colors based on delay
      if (delay === 0) {
        setStartingAlert(`${t("The meeting started on time.")}`);
        setStartingAlertColor("transparent");
        setLeftColor(green);
      } else if (delay > 0) {
        if (delay === 1) {
          setStartingAlert(
            `${t("The meeting started with")} ${delay} ${t("minute late.")}`
          );
          setStartingAlertColor(orange);
          setLeftColor(orange);
        } else if (delay <= 5) {
          setStartingAlert(
            `${t("The meeting started with")} ${delay} ${t("minutes late.")}`
          );
          setStartingAlertColor(orange);
          setLeftColor(orange);
        } else {
          setStartingAlert(
            `${t("The meeting started with")} ${delay} ${t("minutes late.")}`
          );
          setStartingAlertColor(red);
          setLeftColor(red);
        }
      } else {
        const delayMinutes = Math.abs(delay); // Convert to positive for early starts
        setStartingAlert(
          `${t("The meeting started with")} ${delayMinutes} ${t(
            "minutes in advance."
          )}`
        );
        setStartingAlertColor(green);
        setLeftColor(green);
      }
    }
  };

  useEffect(() => {
    if (meetingData) getLeftColors(meetingData);
  }, [meetingData]);

  const formatDelay = (delay) => {
    if (!delay) {
      return;
    }
    // Remove all negative signs from the delay string
    delay = delay.replace(/-/g, "");

    const parts = delay.split(":");

    // Extract the individual components
    const [days, hours, minutes, seconds] = parts?.map((part) =>
      parseInt(part, 10)
    );

    if (days > 0) {
      return `${days}d:${hours}h`;
    } else if (hours > 0) {
      return `${hours}h:${minutes}m`;
    } else {
      return `${minutes}m:${seconds}s`;
    }
  };

  const activeStepDelay = meetingData && meetingData?.steps && stepDelay?.delay;
  //With Timezone
  const formatTime = (dateTimeString, meetingTimezone) => {
    if (!dateTimeString || !meetingTimezone) return null;

    const cleanDateTimeString = dateTimeString.split(".")[0]; // Removes milliseconds and 'Z' // I have to remove this Z because it takes it as a UTC

    const userTimezone = moment.tz.guess() || "Europe/Paris";

    const timeInMeetingTZ = moment.tz(cleanDateTimeString, meetingTimezone);
    const timeInUserTZ = timeInMeetingTZ.clone().tz(userTimezone);

    return `${timeInUserTZ.format("HH")}h${timeInUserTZ.format("mm")}`;
  };

  const estimatedTime =
    meetingData && meetingData.steps && stepDelay?.estimate_time?.split("T")[1];

  const estimatedEndDate =
    meetingData && meetingData.steps && stepDelay?.estimate_time?.split("T")[0];

  const estimateDateTime =
    meetingData && meetingData.steps && stepDelay?.estimate_time;

  const EstimatedEndDateWithTimezone = convertDateToUserTimezone(
    estimatedEndDate,
    estimatedTime,
    meetingData?.timezone
  );

  const formattedTime = estimatedTime
    ? formatTime(estimateDateTime, meetingData?.timezone || "Europe/Paris")
    : "";

  const formattedDelay = formatDelay(activeStepDelay);

  return (
    <ErrorBoundary>
      <div className="counter-container d-flex align-items-center flex-column">
        <div className="d-flex justify-content-center align-items-center ">
          {/* LEFT COUNTER */}
          <div
            className={`d-flex  flex-column ${isModalOpen ? "pt-2" : "pt-3"}`}
          >
            <CountdownCircleTimer
              size={isModalOpen ? 90 : 100}
              strokeWidth={5}
              isPlaying={false}
              duration={0}
              colors={leftColor}
            >
              {/* INSIDE LEFT COUNTER */}
              {({ remainingTime }) => {
                return (
                  <>
                    {meetingData?.type === "Action1" ||
                    meetingData?.type === "Newsletter" ? (
                      <div
                        className="justify-content-center flex-column d-flex align-items-center"
                        style={{
                          fontSize: "medium",
                        }}
                      >
                        <span
                          className="start-at"
                          style={{ fontSize: isModalOpen ? "10px" : "12px" }}
                        >
                          {t("Start At")}
                        </span>
                        <span
                          className="start-at"
                          style={{ fontSize: isModalOpen ? "10px" : "12px" }}
                        >
                          {convertDateToUserTimezone(
                            meetingData?.current_date,
                            meetingData?.starts_at,
                            meetingData?.timezone || "Europe/Paris"
                          )}
                          {/* {meetingData?.current_date} */}
                        </span>
                      </div>
                    ) : (
                      <div
                        className="justify-content-center flex-column d-flex align-items-center"
                        style={{ fontSize: "medium" }}
                      >
                        <span
                          className="start-at"
                          style={{ fontSize: isModalOpen ? "10px" : "10px" }}
                        >
                          {/* {meetingData?.current_date} */}
                          {convertDateToUserTimezone(
                            meetingData?.current_date,
                            meetingData?.starts_at,
                            meetingData?.timezone || "Europe/Paris"
                          )}
                        </span>
                        <span
                          className="start-at"
                          style={{ fontSize: isModalOpen ? "9px" : "10px" }}
                        >
                          {t("Start At")}
                        </span>
                        <h5 style={{ fontSize: isModalOpen ? "12px" : "13px" }}>
                          {hours}h{minutes > 9 ? minutes : "0" + minutes}
                        </h5>
                        {/* {meetingStartTime.getHours()}h
                      {meetingStartTime.getMinutes() > 10
                        ? meetingStartTime.getMinutes()
                        : "0" + meetingStartTime.getMinutes()} */}
                        {/* : + meetingStartTime.getMinutes()} */}
                      </div>
                    )}
                  </>
                );
              }}
            </CountdownCircleTimer>
            {!isModalOpen && (
              <>
                {meetingData?.delay ? (
                  <>
                    <p
                      className="starting-alert"
                      style={{
                        color: "white",
                      }}
                    >
                      {startingAlert}
                    </p>
                  </>
                ) : (
                  <p
                    className="starting-alert"
                    style={{
                      color: startingAlertColor,
                    }}
                  >
                    {startingAlert}
                  </p>
                )}
              </>
            )}
          </div>

          {/* -------------------> CENTER COUNTER <--------------------------------------------------------------------------------------------- */}

          <div
            className={`d-flex  flex-column ${isModalOpen ? "pb-0" : "pb-5"}`}
          >
            {alarm === true ? (
              <>
                {isModalOpen ? (
                  <div className="pb-3"></div>
                ) : (
                    <div className="remainingTime text-center">
                    <p style={{ fontSize: "15px" }}>
                      {t("alarm.alarmByStep")}
                      <br /> {t("alarm.active")}
                    </p>
                  </div>
                )}
              </>
            ) : (
              <div className="pb-3"></div>
            )}
            {meetingData &&
            meetingData?.steps &&
            meetingData?.steps[activeStepIndex].negative_time === "99" ? (
              <>
                <CountdownCircleTimer
                  key={activeStepIndex}
                  size={isModalOpen ? 110 : 130}
                  strokeWidth={5}
                  isPlaying={false}
                  onUpdate={(remainingTime) => {}}
                  colors={redColor}
                >
                  {/* INSIDE  of the Center Counter */}
                  {({ remainingTime }) => {
                    remainingTimeRef.current = remainingTime;
                    return (
                      <div className="justify-content-center flex-column d-flex align-items-center">
                        <h5
                          className="meeting-counter"
                          style={{ fontSize: isModalOpen ? "15px" : "20px" }}
                        >
                          - {meetingData && formattedDelay}
                        </h5>
                        {/* <h6>min</h6> */}
                      </div>
                    );
                  }}
                </CountdownCircleTimer>
              </>
            ) : (
              <CountdownCircleTimer
                key={activeStepIndex}
                size={isModalOpen ? 100 : 130}
                strokeWidth={5}
                isPlaying={true}
                // isPlaying={showNegativeCounter && meetingData?.steps[activeStepIndex].negative_time === '99' ? false : true}
                duration={duration}
                // isGrowing={isGrowing}
                onComplete={(totalElapsedTime) => {
                  if (alarm === true && !buzzerPlayed && remainingTime == 0) {
                    // // PLAY BUZZER AUDIO:
                    buzzer.play().catch((err) => {
                      // console.log("err", err);
                    });
                  }
                  // When Positive Counter is Completed:
                  setTotalElapsedTimeState(totalElapsedTime);
                  setShowNegativeCounter(true);
                  remainingTimeRef.current = 0;
                  setDuration(7200 + totalElapsedTime); // if totalElapsedTime is not added, the negative counter will start from -duration seconds.
                }}
                onUpdate={(remainingTime) => {
                  // BEEPING SOUND WHEN LAST 10 SECONDS ARE LEFT:
                  setRemainingTime(remainingTime);
                  if (
                    remainingTime < 5 &&
                    remainingTime > 0 &&
                    alarm === true
                  ) {
                    // playAudio();
                  }

                  setSpareTimes((prev) => {
                    if (showNegativeCounter) {
                      let timesArray = [...prev];
                      timesArray[activeStepIndex] = 0;
                      return timesArray;
                    } // if the counter is negative, don't update the spare times.
                    let timesArray = [...prev];
                    timesArray[activeStepIndex] = remainingTime;
                    return timesArray;
                  });

                  if (showNegativeCounter) {
                    setCenterColor("red");
                    setRightDuration((prev) => {
                      return prev + 1;
                    });
                    setNegativeTimes((prev) => {
                      let timesArray = [...prev];
                      timesArray[activeStepIndex] =
                        7200 - remainingTimeRef.current;
                      return timesArray;
                    });

                    return;
                  }
                  //                   else{
                  //                     // setRightDuration((prev) => {
                  //                     //   return prev - 1;
                  //                     // });
                  //                     const minutesElapsed = Math.floor((duration - remainingTime) / 60);
                  // console.log('Duration:', duration);
                  // console.log('Remaining Time:', remainingTime);
                  // console.log('Minutes Elapsed:', minutesElapsed);
                  // console.log('Previous Minutes Elapsed:', prevMinutesElapsedRef.current);

                  // if (minutesElapsed >= 1) {
                  //   setRightDuration((prev) => prev - 1);
                  //   prevMinutesElapsedRef.current = minutesElapsed;
                  // }
                  //                   }
                  handleSetSavedTime(remainingTime);
                }}
                colors={showNegativeCounter ? "red" : "#5AAFD6"}
              >
                {/* INSIDE  of the Center Counter */}
                {({ remainingTime }) => {
                  {
                    /* getLeftColors(); */
                  }
                  remainingTimeRef.current = remainingTime;
                  return showNegativeCounter ? (
                    <div className="justify-content-center flex-column d-flex align-items-center">
                      <h3 style={{ fontSize: isModalOpen ? "15px" : "19px" }}>
                        -
                        {(() => {
                          const formattedNegativeTime = remainingTime - 7200;
                          return formatTimeMMSS(-1 * formattedNegativeTime);
                        })()}
                      </h3>
                      <h6>min</h6>
                    </div>
                  ) : (
                    <div>
                      {/* <h3>{formatTimeMMSS(remainingTime)}</h3> */}
                      <h3 style={{ fontSize: isModalOpen ? "15px" : "19px" }}>
                        {meetingData &&
                        meetingData.steps &&
                        meetingData?.steps[activeStepIndex]?.time_unit ===
                          "days"
                          ? formatTimeDDHH(remainingTime)
                          : meetingData &&
                            meetingData?.steps &&
                            meetingData?.steps[activeStepIndex]?.time_unit ===
                              "hours"
                          ? formatTimeHHMM(remainingTime)
                          : formatTimeMMSS(remainingTime)}
                      </h3>
                    </div>
                  );
                }}
              </CountdownCircleTimer>
            )}
            {!isModalOpen && (
              <h5 className="remainingTime text-center meeting-counter mt-2">
                {stepTitle && stepOrder + "." + stepTitle}
              </h5>
            )}
          </div>
          <div>
            <audio ref={audioRef} src="/public/Assets/beep.wav" id="beep" />
          </div>
          {/* RIGHT COUNTER */}

          <div
            className={`d-flex flex-column justify-content-center ${
              isModalOpen ? "pb-0 pt-2" : "pb-5"
            }`}
          >
            <CountdownCircleTimer
              colors="url(#your-unique-id)"
              duration={rightDuration}
              size={isModalOpen ? 90 : 100}
              strokeWidth={4}
              onComplete={(totalElapsedTime) => [totalElapsedTime > 0]}
            >
              {({ remainingTime }) => {
                return (
                  <>
                    <div>
                      {/* {remainingTime} */}
                      {(() => {
                        const estimatedTime =
                          meetingStartTime.getTime() + rightDuration * 1000;
                        // console.log('estimated time:', estimatedTime)
                        // Explanation of Above lie: The meetingStartTime is the time when the meeting will start
                        const time = new Date(estimatedTime);

                        const formattedHours = (time) => {
                          return (
                            time.getHours().toString().padStart(2, "0") +
                            "h" +
                            time.getMinutes().toString().padStart(2, "0")
                          );
                        };
                        // const time = new Date(estimatedTime);
                        // console.log("time:", time);
                        return (
                          <>
                            {meetingData?.type === "Action1" ||
                            meetingData?.type === "Newsletter" ? (
                              <div className="d-flex justify-content-center align-items-center flex-column">
                                <span
                                  className="start-at"
                                  style={{
                                    fontSize: isModalOpen ? "10px" : "10px",
                                  }}
                                >
                                  {t("Estimated End At")}
                                </span>
                                <span
                                  className="start-at"
                                  style={{
                                    fontSize: isModalOpen ? "10px" : "12px",
                                  }}
                                >
                                  {/* {calculateEndDate(
                                    meetingData?.steps,
                                    meetingData?.current_date
                                  )} */}
                                  {(meetingData &&
                                    meetingData?.steps &&
                                    meetingData?.steps[activeStepIndex]
                                      ?.delay) ||
                                  negativeTimes[activeStepIndex] > 0
                                    ? estimatedEndDate
                                    : estimateDate}
                                </span>
                              </div>
                            ) : (
                              <div className="d-flex justify-content-center align-items-center flex-column">
                                <span
                                  className="start-at"
                                  style={{
                                    fontSize: isModalOpen ? "10px" : "10px",
                                  }}
                                >
                                  {(meetingData &&
                                    meetingData?.steps &&
                                    meetingData?.steps[activeStepIndex]
                                      ?.delay) ||
                                  negativeTimes[activeStepIndex] > 0
                                    ? EstimatedEndDateWithTimezone
                                    : estimateDate}
                                  {/* {estimateDate ? estimateDate : estimatedEndDate? estimatedEndDate : calculateEndDate(
                                    meetingData?.steps,
                                    meetingData?.current_date,
                                    meetingData?.start_time
                                  )} */}
                                </span>
                                {/* <div> */}
                                <span
                                  className="start-at"
                                  style={{
                                    fontSize: isModalOpen ? "10px" : "10px",
                                  }}
                                >
                                  {t("Estimated End At")}
                                </span>
                                {/* </div> */}
                                <h5
                                  className="meeting-counter"
                                  style={{
                                    fontSize: isModalOpen ? "12px" : "13px",
                                  }}
                                >
                                  {(meetingData &&
                                    meetingData?.steps &&
                                    meetingData?.steps[activeStepIndex]
                                      ?.delay) ||
                                  negativeTimes[activeStepIndex] > 0
                                    ? formattedTime
                                    : estimateTime}
                                </h5>
                                {/* <h5>{formattedTime ? formattedTime : formattedHours(time)}</h5> */}
                                {/* <h5>{formattedHours(time)}</h5> */}
                              </div>
                            )}
                          </>
                        );
                      })()}
                    </div>
                  </>
                );
              }}
            </CountdownCircleTimer>

            <section></section>
          </div>
        </div>

        {/* BOTTOM ROW */}
        <div className="d-flex justify-content-center gap-2 align-items-center "></div>
      </div>
    </ErrorBoundary>
  );
};

//With stop timer button
// const CounterContainer = ({ alarm, progress }) => {
//   console.log('showProgressBar', progress);
//   const audioRef = useRef(null);
//   const [audio] = useState(new Audio(`https://exoux.com/beep.WAV`));
//   const [buzzer] = useState(new Audio(`https://exoux.com/Final-Countdown%20(mp3cut.net).mp3`));
//   const [t] = useTranslation("global");
//   const prevStepRef = useRef(false);
//   const nextStepRef = useRef(false);
//   const {
//     activeStepIndex,
//     meetingData,
//     handleSetSavedTime,
//     negativeTimes,
//     setNegativeTimes,
//     setNextActiveStep,
//     setPreviousActiveStep,
//     nextStepTrigger,
//     previousStepTrigger,
//   } = useCounterContext();
//   const [duration, setDuration] = useState(0);
//   const [initialRemainingTimeState, setInitialRemainingTimeState] = useState(0);
//   const remainingTimeRef = useRef(0);
//   const [totalElapsedTimeState, setTotalElapsedTimeState] = useState(0);
//   const [meetingStartTime, setMeetingStartTime] = useState(new Date());
//   const [leftDuration, setLeftDuration] = useState(0);
//   const [rightDuration, setRightDuration] = useState(0);
//   const [showNegativeCounter, setShowNegativeCounter] = useState(false);
//   const [loaded, setLoaded] = useState(false);
//   const [isGrowing, setIsGrowing] = useState(false);
//   const [centerColor, setCenterColor] = useState("#5AAFD6");
//   const [leftColor, setLeftColor] = useState("#eee");
//   const [startingAlert, setStartingAlert] = useState("");
//   const [startingAlertColor, setStartingAlertColor] = useState("0000");
//   const [spareTimes, setSpareTimes] = useState([]);
//   const [isOnPage, setIsOnPage] = useState(true);
//   const [leavingTime, setLeavingTime] = useState(0);
//   const [isPlaying, setIsPlaying] = useState(false); // Add state for playing

//   useEffect(() => {
//     if (progress) return;
//     setShowNegativeCounter(false);
//     if (negativeTimes[activeStepIndex] > 0) {
//       setShowNegativeCounter(true);
//       setDuration(7200 - negativeTimes[activeStepIndex]);
//       return;
//     }
//     const steps = meetingData.steps;
//     if (Array.isArray(steps) && steps.length > 0) {
//       const step = steps[activeStepIndex];
//       setDuration(step.savedTime || step.time * 60);
//     }
//     setCenterColor("#5AAFD6");
//   }, [activeStepIndex, meetingData, progress]);

//   useEffect(() => {
//     if (progress) return;
//     const handleSwitch = () => {
//       setIsOnPage(!isOnPage);
//       const timeOfSwitching = moment();

//       if (document.visibilityState === "hidden") {
//         setLeavingTime(timeOfSwitching);
//       } else if (document.visibilityState === "visible" && leavingTime) {
//         const timeDifferenceInSeconds = moment.duration(timeOfSwitching.diff(leavingTime)).asSeconds();
//         const ceilingTimeDifference = Math.ceil(timeDifferenceInSeconds);
//         setRightDuration((prev) => prev + ceilingTimeDifference);
//       }
//     };

//     document.addEventListener("visibilitychange", handleSwitch);

//     return () => {
//       document.removeEventListener("visibilitychange", handleSwitch);
//     };
//   }, [leavingTime, progress]);

//   useEffect(() => {
//     if (progress) return;

//     if (loaded === false && !meetingData) return;
//     if (meetingData && loaded === false) {
//       setSpareTimes(new Array(meetingData.steps.length).fill(0));
//       const totalTimesArray = meetingData?.steps?.map((step) => {
//         if (!step.savedTime) return parseInt(step.time) * 60;
//         let elapsedTime = parseInt(step.time) - parseInt(step.savedTime);
//         return parseInt(step.time) - parseInt(elapsedTime);
//       });

//       let totalTime = totalTimesArray?.reduce((acc, curr) => acc + curr, 0);
//       setRightDuration(totalTime);
//       setLoaded(true);
//     }
//   }, [meetingData, loaded, progress]);

//   const stopAudio = () => {
//     buzzer.pause();
//     buzzer.currentTime = 0;
//   };

//   const intervalRef = useRef(null);
//   useEffect(() => {
//     if (progress) {
//       if (intervalRef.current) {
//         clearInterval(intervalRef.current);
//       }
//       return;
//     }

//     if (isPlaying) {
//       intervalRef.current = setInterval(() => {}, 1000);
//     }

//     return () => {
//       clearInterval(intervalRef.current);
//     };
//   }, [progress, isPlaying]);

//   useEffect(() => {
//     if (progress) return;

//     if (nextStepRef.current) {
//       stopAudio();
//       const spareTimeToBeSubtracted = spareTimes[activeStepIndex - 1];
//       setRightDuration((prev) => prev - spareTimeToBeSubtracted);
//     }
//     return () => {
//       nextStepRef.current = true;
//     };
//   }, [nextStepTrigger, progress]);

//   useEffect(() => {
//     if (progress) return;

//     if (prevStepRef.current) {
//       stopAudio();
//       const spareTimeToBeAdded = spareTimes[activeStepIndex];
//       setRightDuration((prev) => prev + spareTimeToBeAdded);
//     }

//     return () => {
//       prevStepRef.current = true;
//     };
//   }, [previousStepTrigger, progress]);

//   const playAudio = () => {
//     audio.play().catch((err) => {});
//   };

//   const getLeftColors = async (meetingData) => {
//     const green = "#39FF14";
//     const red = "url(#your-unique-id2)";
//     const orange = "#f67913";
//     const scheduledMinutes = parseInt(meetingData.start_time.split(":")[1], 10);
//     const minutes = meetingStartTime.getMinutes();
//     let delay = minutes - scheduledMinutes;

//     if (delay === 0 || delay === 1) {
//       setStartingAlert(` ${t("The meeting started with")} ${delay} ${t("Minutes in Advance")}.`);
//       setStartingAlertColor("transparent");
//       setLeftColor(green);
//       return;
//     }
//     if (delay > 1 && delay <= 5) {
//       setStartingAlert(` ${t("The meeting started with")} ${delay} ${t("Minutes in Advance")}.`);
//       setStartingAlertColor(orange);
//       setLeftColor(orange);
//       return;
//     }
//     if (delay > 5) {
//       setStartingAlert(` ${t("The meeting started with")} ${delay} ${t("Minutes in Advance")}.`);
//       setStartingAlertColor(red);
//       setLeftColor(red);
//       return;
//     }
//     if (delay < 0) {
//       const delayMinutes = -1 * delay;
//       setLeftColor(green);
//       setStartingAlertColor(green);
//       setStartingAlert(` ${t("The meeting started with")} ${delayMinutes} ${t("Minutes in Advance")}.`);
//     }
//   };

//   useEffect(() => {
//     if (meetingData) getLeftColors(meetingData);
//   }, [meetingData]);

//   return (
//     <ErrorBoundary>
//       <div className="counter-container">
//         <div className="d-flex justify-content-center align-items-center">
//           <div className="d-flex flex-column pt-4">
//             <CountdownCircleTimer
//               size={100}
//               strokeWidth={5}
//               isPlaying={false}
//               duration={0}
//               colors={leftColor}
//             >
//               {({ remainingTime }) => (
//                 <div className="justify-content-center flex-column d-flex align-items-center">
//                   <span className="start-at">{t("Start At")}</span>
//                   {meetingStartTime.getHours()}h
//                   {meetingStartTime.getMinutes() > 10
//                     ? meetingStartTime.getMinutes()
//                     : "0" + meetingStartTime.getMinutes()}
//                 </div>
//               )}
//             </CountdownCircleTimer>
//             <p className="starting-alert" style={{ color: startingAlertColor }}>
//               {startingAlert}
//             </p>
//           </div>

//           <div className="d-flex flex-column pb-5">
//             {alarm === "1" ? (
//               <div className="remainingTime text-center">
//                 <p style={{ fontSize: "15px" }}>
//                   Alarme par étape
//                   <br /> activée
//                 </p>
//               </div>
//             ) : (
//               <div className="pb-3"></div>
//             )}
//             <CountdownCircleTimer
//               key={activeStepIndex}
//               size={130}
//               strokeWidth={5}
//               isPlaying={isPlaying}
//               duration={duration}
//               onComplete={(totalElapsedTime) => {
//                 if (alarm === "1") {
//                   buzzer.play().catch((err) => {});
//                 }
//                 setTotalElapsedTimeState(totalElapsedTime);
//                 setShowNegativeCounter(true);
//                 remainingTimeRef.current = 0;
//                 setDuration(7200 + totalElapsedTime);
//               }}
//               onUpdate={(remainingTime) => {
//                 if (remainingTime < 5 && remainingTime > 0 && alarm === "1") {
//                   playAudio();
//                 }
//                 setSpareTimes((prev) => {
//                   if (showNegativeCounter) {
//                     let timesArray = [...prev];
//                     timesArray[activeStepIndex] = 0;
//                     return timesArray;
//                   }
//                   let timesArray = [...prev];
//                   timesArray[activeStepIndex] = remainingTime;
//                   return timesArray;
//                 });

//                 if (showNegativeCounter) {
//                   setCenterColor("url(#your-unique-id2)");
//                   setRightDuration((prev) => prev + 1);
//                   setNegativeTimes((prev) => {
//                     let timesArray = [...prev];
//                     timesArray[activeStepIndex] = 7200 - remainingTimeRef.current;
//                     return timesArray;
//                   });

//                   return;
//                 }
//                 handleSetSavedTime(remainingTime);
//               }}
//               colors={centerColor}
//             >
//               {({ remainingTime }) => {
//                 remainingTimeRef.current = remainingTime;
//                 return showNegativeCounter ? (
//                   <div className="justify-content-center flex-column d-flex align-items-center">
//                     <h3>
//                       -
//                       {(() => {
//                         const formattedNegativeTime = remainingTime - 7200;
//                         return formatTimeMMSS(-1 * formattedNegativeTime);
//                       })()}
//                     </h3>
//                     <h6>min</h6>
//                   </div>
//                 ) : (
//                   <div>
//                     <h3>{formatTimeMMSS(remainingTime)}</h3>
//                   </div>
//                 );
//               }}
//             </CountdownCircleTimer>
//             <h5 className="remainingTime text-center">
//               {t("Remaining time of stage")}
//             </h5>
//           </div>
//           <div>
//             <audio ref={audioRef} src="/public/Assets/beep.wav" id="beep" />
//           </div>

//           <div className="d-flex flex-column justify-content-center pb-5">
//             <CountdownCircleTimer
//               colors="url(#your-unique-id)"
//               duration={rightDuration}
//               size={100}
//               strokeWidth={4}
//               onComplete={(totalElapsedTime) => [totalElapsedTime > 0]}
//             >
//               {({ remainingTime }) => {
//                 return (
//                   <div>
//                     {(() => {
//                       const estimatedTime =
//                         meetingStartTime.getTime() + rightDuration * 1000;
//                       const time = new Date(estimatedTime);
//                       return (
//                         <div className="d-flex justify-content-center align-items-center flex-column">
//                           <div>
//                             <span className="start-at">
//                               {t("Estimated End At")}
//                             </span>
//                           </div>
//                           <h5>{`${time.getHours()}h${
//                             time.getMinutes() < 10
//                               ? "0" + time.getMinutes()
//                               : time.getMinutes()
//                           }`}</h5>
//                         </div>
//                       );
//                     })()}
//                   </div>
//                 );
//               }}
//             </CountdownCircleTimer>

//             <section></section>
//           </div>
//         </div>

//         <div className="d-flex justify-content-center gap-2 align-items-center">
//           <button onClick={() => setIsPlaying(!isPlaying)}>
//             {isPlaying ? "Stop" : "Start"} Timer
//           </button>
//         </div>
//       </div>
//     </ErrorBoundary>
//   );
// };

export default CounterContainer;
